import { render, staticRenderFns } from "./ApproveSenderId.vue?vue&type=template&id=14f04da6&"
import script from "./ApproveSenderId.vue?vue&type=script&lang=js&"
export * from "./ApproveSenderId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports